import {makeStyles} from "@material-ui/core/styles";
import Modal from "../Generales/ModalCerrarActualiza";
import {useEffect, useRef, useState} from "react";
import {Button, Grid, Box, Select, FormControl, InputLabel} from "@material-ui/core";
import axios from "axios";
import qs from 'qs';
import {toast} from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import {v4 as uuidv4} from 'uuid';
import Progress from "../Generales/Progress";
import {ErrorGeneral, llamaApiFormData, llamadaApiToken} from '../funciones/ClienteAxios';
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import CardDet from "./CardDet";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    }, imageList: {
        maxHeight: 450, maxWidth: 500
    }, icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    }, "@global": {
        '#form-file-upload': {
            textAlign: 'center', position: 'relative', width: 550
        }, '#input-file-upload': {
            display: 'none',
        // }, '#label-file-upload': {
        //     height: '100%',
        //     display: 'flex',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        //     borderWidth: '2px',
        //     borderRadius: '1rem',
        //     borderStyle: 'dashed',
        //     borderColor: theme.palette.secondary.main,
        //     paddingTop: 25,
        //     paddingBottom: 25
        },
        'upload-button': {
            cursor: 'pointer',
            padding: '0.25rem',
            fontSize: '1rem',
            border: 'none',
            fontFamily: 'Oswald',
            backgroundColor: 'transparent'
        }, 'upload-button:hover': {
            textDecorationLine: 'underline'
        }, '#label-file-upload.drag-active': {
            backgroundColor:process.env.REACT_APP_Color_Second, color: 'white'
        }, '#drag-file-element': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            borderRadius: '1rem',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    },
}));

const ModalAgregarEvidencia = ({abrirModal, setAbrirModal, selectedID, idusu, setUpdate,beca, listTipo}) => {

    const classes = useStyles();
    const inputRef = useRef(null);
    let history = useHistory();
    const source = axios.CancelToken.source();
    const [btnDeshabilitado, setBotonDeshabilitado] = useState(true)
    const [aviso, setAviso] = useState(false);
    const [espera, setEspera] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [size, setSize] = useState(0);
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [dragActive, setDragActive] = useState(false);
    const [arraySubidos, setArraySubidos] = useState([])
    const [arrayPreview, setArrayPreview] = useState([])
    const formData = new FormData();
    const [progresoEnvio, setProgresoEnvio] = useState(0);
    const [fecha, setFecha] = useState(moment.utc(new Date).format("DD-MM-YYYY"));    
    const [evidencia, setEvidencia] = useState({tipo:0});        
    const [listDoc, setListDoc] = useState([]);        
    const [listDocReg, setListDocReg] = useState([]);        
    const [listAvisoEvid, setListAvisoEvid] = useState([]);        
    const [banderaSubir, setBanderaSubir] = useState(false);        
    const {tipo} = evidencia;

    useEffect(() => {
       if (beca.length!==0) 
       {    
            setFecha( moment.utc(beca.FReg).format("DD-MM-YYYY"))
       }
       getListDoc()
    }, [ ])
    
    useEffect(()=>{
        if (listDoc.length!==0) {
            let auxList =[]
            listTipo.forEach((auxTipo)=>{              
                if (auxTipo.Id!==0 && auxTipo.Id !== -1 ) {
                    
                    const filtro = listDoc.filter((Documento)=>Documento.TipoId === auxTipo.Id)  
                    if (filtro.length!==0) {
                        auxList.push({IdReg: filtro[0].Id, DirReg: filtro[0].Dir, ArchivoReg: filtro[0].Archivo,
                            Tipo: filtro[0].TipoId, TipoNom: filtro[0].TipoNom
                        })    
                    }
                    else
                    {   auxList.push({IdReg: 0, DirReg: "", ArchivoReg: "",
                            Tipo: auxTipo.Id, TipoNom: auxTipo.Nom
                        })    
                    }                
                }
            })
            //console.log(auxList);
            
            setListDocReg(auxList)
        }
    },[listDoc])

    useEffect(() => {
        if (listAvisoEvid.length !== 0) {
            setBotonDeshabilitado(false)
        } else {
            setBotonDeshabilitado(true)
        }
        
    }, [listAvisoEvid]);

    const getListDoc = () => {      
        const data = qs.stringify({
          Usuario:idusu,
          Llave:beca.Id,
          idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/registro/v1/file/list";
        function respuesta(aux) {
          if (aux[0].Id !== -1) 
          {                        
            setListDoc(aux);                             
          }
        }            
        llamadaApiToken(data, url, respuesta,ErrorGeneral,history,source)
    };

    const handleChange = function (event) {
        const regex = /([a-zA-Z0-9\s_.\-():])+(.jpg|.jpeg|png)$/
        let image = event.target.files[0]
        let auxCode = uuidv4();
        if (image && image.name.toLowerCase().match(regex)) {
            let auxNombre = auxCode + image.name.slice(image.name.lastIndexOf("."), image.name.length);
            let myNewFile = new File([image], auxNombre, {type: image.type});
            setArraySubidos([...arraySubidos, myNewFile])
            setArrayPreview([...arrayPreview, URL.createObjectURL(image)])
        } else {
            let nombre = "";
            if (image.name.length >= 25) {
                nombre = image.name.substring(0, 24) + "..." + image.name.substring(image.name.lastIndexOf("."), image.name.length);
            } else {
                nombre = image.name;
            }
            let mensaje = `Formato de archivo incorrecto en ${nombre} seleccione una imagen tipo jpg,jpeg o png.`
            toast.warning(mensaje, {
                pauseOnFocusLoss: false,
                theme: "colored",
                toastId: `incorrecto-sel`
            });
        }
    }

    const onChangeSlct = e =>
    {
        setEvidencia({ ...evidencia, [e.target.name] : e.target.value  })
    };

        
    const onButtonClick = () => {
        inputRef.current.click();
    };

    const removeElement = (index) => {
        let newArr = arraySubidos.filter(element => element !== arraySubidos[index]);
        let newArr2 = arrayPreview.filter(element => element !== arrayPreview[index]);
        setArraySubidos(newArr)
        setArrayPreview(newArr2)
    };

    const handleClose = () => {
        setAbrirModal(false)
        setAviso(false);
    }


    function guardarDatos(e) {
        e.preventDefault()

        if (arraySubidos.length !== 0) {
         
        } else {
            toast.warning(`Debe seleccionar una imagen para subir`, {
                pauseOnFocusLoss: false,
                theme: "colored",
                toastId: `incorrecto-sel`
            });
        }
    }

    const slctTipo=  listTipo.length !== 0 ?
        <FormControl style={{width:"15rem"}} size="small" >
          <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
          <Select
            native value={tipo} onChange={onChangeSlct}
            inputProps={{ name: 'tipo', id: 'tipoSlct',}}
          >
            <option aria-label="None" value="" />                     
            {listTipo.map((row,index) => (
              <option value={row.Id} key={index} >{row.Nom}</option>
            ))}   
          </Select>
        </FormControl>     
      :null    

    return (
    <Modal
        titulo={'Subir Documentos ' + fecha} modalAbierto={abrirModal} mensaje={mensaje}
        setModalAbierto={setAbrirModal} guardarDatos={guardarDatos}
        tipoAdvertencia={tipoAdvertencia} aviso={aviso} tamanio={'md'}
        btnDeshabilitado={btnDeshabilitado} setAviso={setAviso}
        cargando={espera} cerrarBorrar={handleClose}
    >
        <Grid container alignItems={'center'} justifyContent={'center'} spacing={1} style={{width:"100%"}}>
     
            <Box display={"flex"} flexDirection={"column"} style={{width:"40rem"}} >
            { listDocReg.length !== 0 ? 
                listDocReg.map((docReg, index)=>{
                    return(
                        <CardDet element={docReg} index={index} beca={beca} banderaSubir={banderaSubir}
                            setListAvisoEvid={setListAvisoEvid} listAvisoEvid={listAvisoEvid}
                        />
                    )
                })
                :null
            }
            </Box>
        </Grid>

    </Modal>);
};

export default ModalAgregarEvidencia;